import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: 'bank',
    title: 'Update Bank',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/add-transactions.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Upload Bank',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/upload-document.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Upload MT103',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/upload-document.svg',
    submenu: [],
  },
  {
    path: '',
    title: 'Add Entity',
    icon: 'bi bi-speedometer2',
    class: '',
    extralink: false,
    image: './assets/images/icon/upload-document.svg',
    submenu: [],
  },
];

